module.exports = __webpack_public_path__ + "img/logo-h.8383bf44.png";